module.exports = __webpack_public_path__ + "static/media/29ADMSPC22.61df44b4.jpg";